






import { Vue, Component, Prop } from "vue-property-decorator";
import { Activity } from "@/graphql/query/activity/feed";
import { RoomLink } from "./helper";

@Component({ components: { RoomLink } })
export default class CreateFamilyKeyLog extends Vue {
  @Prop({ type: Object, required: true }) activity!: Activity;
}
